import React from 'react';
import { Logger } from 'aws-amplify';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Box } from '@material-ui/core';
import { useBankingDefaultsSettingsForm } from './useBankingDefaultsSettingsForm';
import { RootState } from '../../../store';
import { BillingSettings } from '../../../constants';
import { updateBillingSettings } from '../../../store/settings/actions';
import { Loader } from '../../Loading';
import { SettingsPageForm } from '../SettingsPageForm';

export const initialDefaultsFormValue: BillingSettings = {
  allowPaymentViaCC: true,
  allowPaymentViaACH: true,
  absorbTransactionFees: false,
  defaultMemo: '',
};

const logger = new Logger('BankingDefaultsSettings');
export const BankingDefaultsSettings: React.FC = () => {
  const dispatch = useDispatch();
  const { billingSettings, isSettingLoaded } = useSelector(
    (state: RootState) => ({
      billingSettings: state.settings.billingSettings,
      isSettingLoaded: state.settings.loaded,
    }),
    shallowEqual,
  );

  const handleSave = async (values: any) => {
    await dispatch(updateBillingSettings(values));
  };

  return isSettingLoaded ? (
    <SettingsPageForm
      initialFormValue={
        !isEmpty(billingSettings) ? billingSettings : initialDefaultsFormValue
      }
      useFormHook={useBankingDefaultsSettingsForm}
      handleSave={handleSave}
    />
  ) : (
    // Should use loader for now, cuz loadingWrapper is causing
    // a positioning issue on the form save bar.
    // TODO: will create a separate improvement
    <Box
      width={1}
      height={1}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Loader />
    </Box>
  );
};
